import { AxiosResponse } from "axios";
import axios, { APIWrapperResponse, DefaultResponse, TypedResponse } from "../general/HttpClient";

export function getOrganizationGuild() {
    return axios.get("/api/Discord/GetOrganizationGuild").then((response: AxiosResponse<APIWrapperResponse<TypedResponse<DiscordGuild>>>) => {
        return response.data.result;
    });
}

export function getOrganizationServer() {
    return axios.get("/api/Discord/GetOrganizationServer").then((response: AxiosResponse<APIWrapperResponse<TypedResponse<DiscordServerViewModel>>>) => {
        return response.data.result;
    });
}

export function removeOrganizationServer(data: RemoveOrganizationServerRequest) {
    return axios.post("/api/Discord/removeOrganizationServer", data).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function listRoles() {
    return axios.get("/api/Discord/ListRoles").then((response: AxiosResponse<APIWrapperResponse<TypedResponse<DiscordRole[]>>>) => {
        return response.data.result;
    });
}

export function listChannels() {
    return axios.get("/api/Discord/ListChannels").then((response: AxiosResponse<APIWrapperResponse<TypedResponse<DiscordChannel[]>>>) => {
        return response.data.result;
    });
}

export function listCategories() {
    return axios.get("/api/Discord/ListCategories").then((response: AxiosResponse<APIWrapperResponse<TypedResponse<DiscordChannel[]>>>) => {
        return response.data.result;
    });
}

export function linkExistingCategory(request: LinkCategoryRequest) {
    return axios.post("/api/Discord/LinkExistingCategory", request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function linkExistingRole(request: LinkRoleRequest) {
    return axios.post("/api/Discord/LinkExistingRole", request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function removeServerRole(request: RemoveRoleRequest) {
    return axios.post("/api/Discord/RemoveServerRole", request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function createCategory(request: CreateCategoryRequest) {
    return axios.post("/api/Discord/CreateCategory", request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function createChannels(request: CreateChannelsRequest) {
    return axios.post("/api/Discord/CreateChannels", request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function linkDiscordAccount(aliasID: string) {
    return axios.post("/api/Discord/LinkDiscordAccount", {}, { params: { aliasID } }).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function joinDiscordServer() {
    return axios.post("/api/Discord/JoinDiscordServer", {}).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function getUserAliasesInServer() {
    return axios.get("/api/Discord/GetUserAliasesInServer").then((response: AxiosResponse<APIWrapperResponse<TypedResponse<{ [key: string]: boolean }>>>) => {
        return response.data.result;
    });
}

export interface DiscordChannel {
    id: string;
    last_message_id: string;
    type: ChannelType;
    name: string;
    position: number;
    flags: number;
    parent_id: string;
    topic: any;
    guild_id: string;
    permission_overwrites: any[];
    rate_limit_per_user: number;
    nsfw: boolean;
    bitrate: number;
    user_limit: number;
    rtc_region: any;
}

export interface DiscordRole {
    id: string;
    name: string;
    permissions: string;
    color: number;
    hoist: boolean;
    icon: string;
    unicode_emoji: string;
    mentionable: boolean;
    position: number;
    managed: boolean;
    tags: any;
}

export enum ChannelType {
    GUILD_TEXT = 0,
    DM = 1,
    GUILD_VOICE = 2,
    GROUP_DM = 3,
    GUILD_CATEGORY = 4,
    GUILD_ANNOUNCEMENT = 5,
    ANNOUNCEMENT_THREAD = 10,
    PUBLIC_THREAD = 11,
    PRIVATE_THREAD = 12,
    GUILD_STAGE_VOICE = 13,
    GUILD_DIRECTORY = 14,
    GUILD_FORUM = 15,
}

export interface LinkCategoryRequest {
    categoryID: string;
}

export interface DiscordServerViewModel {
    id: string;
    organizationID: string;
    guildID: string;
    name: string;
    categoryID: string;
    roles: DiscordServerRole[];
    guild: DiscordGuild;
}

export interface RemoveOrganizationServerRequest {
    serverID: string;
}

export interface DiscordServerRole {
    roleID: string;
    roleName: string;
    isDefault: boolean;
}

export interface CreateCategoryRequest {}

export interface CreateChannelsRequest {
    textChannels: string[];
    voiceChannels: string[];
}

export interface LinkRoleRequest {
    roleID: string;
    isDefault: boolean;
}

export interface RemoveRoleRequest {
    serverID: string;
    roleID: string;
}

export interface DiscordGuild {
    id: string;
    name: string;
    icon: string;
    splash: any;
    discovery_splash: any;
    emojis: any[];
    features: string[];
    approximate_member_count: number;
    approximate_presence_count: number;
    description: string;
    stickers: any[];
}
